import { useEffect } from 'react';
import {
  BrokerShipperSidebarPage,
} from '../constants/notificationSidebarAllocation';
import Logger from '../services/logger';

export type SidebarRouteAckPage = BrokerShipperSidebarPage | 'dashboard';

const ROUTE_ACK_ENTRIES_RAW: ReadonlyArray<{ pathPrefix: string; page: SidebarRouteAckPage }> = [
  { pathPrefix: '/shipper/driver-updates', page: 'driverUpdates' },
  { pathPrefix: '/shipper/shipping-schedule', page: 'shippingSchedule' },
  { pathPrefix: '/shipper/schedule', page: 'shippingSchedule' },
  { pathPrefix: '/shipper/orders', page: 'purchaseOrders' },
  { pathPrefix: '/shipper/purchase-orders', page: 'purchaseOrders' },
  { pathPrefix: '/shipper/test-purchase-order', page: 'purchaseOrders' },
  { pathPrefix: '/shipper/create-shipment', page: 'purchaseOrders' },
  { pathPrefix: '/shipper/partners', page: 'carrierPartners' },
  { pathPrefix: '/shipper/carrier-partners', page: 'carrierPartners' },
  { pathPrefix: '/shipper/multi-load-assignment', page: 'purchaseOrders' },
  { pathPrefix: '/shipper/invoices', page: 'payments' },
  { pathPrefix: '/shipper/archive', page: 'shipmentArchive' },
  { pathPrefix: '/shipper/dashboard', page: 'dashboard' },
  { pathPrefix: '/broker/driver-updates', page: 'driverUpdates' },
  { pathPrefix: '/broker/shipping-schedule', page: 'shippingSchedule' },
  { pathPrefix: '/broker/broker-shipping-schedule', page: 'shippingSchedule' },
  { pathPrefix: '/broker/purchase-orders', page: 'purchaseOrders' },
  { pathPrefix: '/broker/create-po', page: 'purchaseOrders' },
  { pathPrefix: '/broker/multi-load-assignment', page: 'purchaseOrders' },
  { pathPrefix: '/broker/carrier-partners', page: 'carrierPartners' },
  { pathPrefix: '/broker/pay-invoices', page: 'payments' },
  { pathPrefix: '/broker/shipment-archive', page: 'shipmentArchive' },
  { pathPrefix: '/broker/dashboard', page: 'dashboard' },
];

/** Longest-prefix-first so nested routes resolve to the correct sidebar page. */
const ROUTE_ACK_ENTRIES = [...ROUTE_ACK_ENTRIES_RAW].sort(
  (a, b) => b.pathPrefix.length - a.pathPrefix.length
);

export function resolveSidebarPageFromPath(pathname: string): SidebarRouteAckPage | null {
  const normalized = pathname.replace(/\/$/, '') || '/';

  for (const { pathPrefix, page } of ROUTE_ACK_ENTRIES) {
    if (normalized === pathPrefix || normalized.startsWith(`${pathPrefix}/`)) {
      return page;
    }
  }

  if (normalized === '/shipper' || normalized === '/broker') {
    return 'dashboard';
  }

  return null;
}

/**
 * Ack sidebar notifications when the user lands on a page (refresh, deep link, in-app nav),
 * not only when they click a sidebar NavLink.
 */
export function useSidebarRouteAck(
  markPageVisited: (page: SidebarRouteAckPage) => Promise<void>,
  pathname: string
): void {
  useEffect(() => {
    const page = resolveSidebarPageFromPath(pathname);
    if (!page) return;

    void markPageVisited(page).catch((err) => {
      Logger.warn('[useSidebarRouteAck] Failed to ack sidebar page visit', {
        err,
        pathname,
        page,
      });
    });
  }, [pathname, markPageVisited]);
}
